import { format } from "date-fns";
import { BsPlusCircleFill } from 'react-icons/bs'
import { formatCPFCNPJ } from "../../../../../../../utils/formatCPFCNPJ";
import { useAuth } from '../../../../../../../context/AuthContext'
import { useDividas } from '../../../../../../../context/DividasContext'
import { useCheckBoxCadastro } from '../../../../../../../hooks/CheckboxCadastroContext'
import { useModal } from '../../../../../../../hooks/ModalContext'
import { DevedorData } from "../../../../../../../types/devedor-data-interface";
import { Button } from "../../../../../../generics/button";
import { Radio } from "../../../../../../generics/radio";
import { CurrencyInput } from "../../../../../../generics/currency-input";
import { InputBlock } from "../../../../../../generics/input-block";
import { TabelaTelefone } from "../tabela-telefone";
import { TabelaEmail } from "../tabela-email";
// import plusCircleIcon from "../../../../../../../assets/icon/plus_circle.svg";
import { GenericModal } from "../../../../../../Modal";
import { useCadastro } from "../../../../../../../context/CadastroContext";
import { useMutation } from "@tanstack/react-query";
import { apiModulo } from "../../../../../../../services/api";
import { useFila } from "../../../../../../../context/FilaContext";
import { usePropostas } from "../../../../../../../context/PropostasContext";
import { useState, useEffect, useCallback } from "react";

interface Item {
  id: string;
  descricao: string
}

interface FormProps {
  credor?: number;
  url?: string;
}

interface HandleChangeProps {
  event?: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  name?: string;
  value?: string;
}

export const Form = ({ credor, url }: FormProps) => {
  const { setModal, modalInfo, onClose } = useModal();
  const { getTodosChecked, isTodosChecked } = useCheckBoxCadastro()
  const { devedorCadastro, devedor, selectedCredor, getDevedorCadastro } = useDividas()
  const { atualizaDevedorCadastro, getClientData, clientData, ultimoCPF, getUltimoCPF, setEndereco, setInadimpelcia, setRenda, renda, inadimplencia, endereco } = useCadastro()
  const { getSelectedProposta, getDateVencimento, setEmailChecked, setSMSChecked } = usePropostas()
  const { decodedToken, cookies } = useAuth()
  // const [inadimplencia, setInadimpelcia] = useState(false)
  // const [endereco, setEndereco] = useState(false)
  // const [renda, setRenda] = useState(false)
  const [user, setUser] = useState<any>()


  const motivoInadimplencia = useMutation({
    mutationFn: () => apiModulo.post('/options', { codcredor: selectedCredor.credor_crm, url: selectedCredor.url_ws, legenda: 'MOTIVO_INADIMPLENCIA' }),
    //  mutationKey: ['form'] 
  })

  const estadoCivil = useMutation({
    mutationFn: () => apiModulo.post('/options', { codcredor: selectedCredor.credor_crm, url: selectedCredor.url_ws, legenda: 'ESTADO_CIVIL' }),
    //  mutationKey: ['form'] 
  })

  useEffect(() => {
    if (devedor?.cpf_cnpj !== ultimoCPF) {
      getTodosChecked(false)
      setInadimpelcia(false)
      setEndereco(false)
      setRenda(false)
      setSMSChecked({ isChecked: false, value: '' })
      setEmailChecked({ isChecked: false, value: '' })
    }
  }, [devedor.cpf_cnpj, ultimoCPF])

  useEffect(() => {
    if (devedor?.cpf_cnpj !== ultimoCPF) {
      getUltimoCPF(devedor?.cpf_cnpj)


      getSelectedProposta()
      getDateVencimento('')


      getTodosChecked(false)
      setInadimpelcia(false)
      setEndereco(false)
      setRenda(false)

      if (devedorCadastro && devedorCadastro?.cpfcnpj) {
        getClientData({
          bairro: devedorCadastro?.enderecos.desbairr,
          nome: devedorCadastro?.nomclien,
          cpf: devedorCadastro?.cpfcnpj,
          cep: devedorCadastro?.enderecos.descep,
          endereco: devedorCadastro?.enderecos.desender,
          numero: devedorCadastro?.enderecos.desnumer,
          complemento: devedorCadastro?.enderecos.descompl,
          cidade: devedorCadastro?.enderecos.descidad,
          uf: devedorCadastro?.enderecos.desestad,
          empresa: devedorCadastro?.dadoscadastrais.empresa,
          cargo: devedorCadastro?.dadoscadastrais.cargo,
          renda: Number(devedorCadastro?.dadoscadastrais.renda),
          diapgto: devedorCadastro?.dadoscadastrais.dia_pgto,
          estadocivil: devedorCadastro?.dadoscadastrais.estadocivil,
          motivoinadimplencia: devedorCadastro?.dadoscadastrais.motivoinadimplencia,
        })
      }
    }

  }, [devedorCadastro])

  function changeInadimplecia() {
    if (isTodosChecked) {
      if (clientData?.motivoinadimplencia && clientData?.motivoinadimplencia !== '') {
        setInadimpelcia(true)
      }
    } else {
      setInadimpelcia(!inadimplencia)
    }
  }

  useEffect(() => {
    motivoInadimplencia.mutateAsync()
    estadoCivil.mutateAsync()
  }, [])

  useEffect(() => {
    if (isTodosChecked) {
      if (clientData?.motivoinadimplencia && clientData?.motivoinadimplencia !== '') {
        setInadimpelcia(true)
      }
      setEndereco(true)
    }
    // else {
    //   setInadimpelcia(false)
    //   setEndereco(false)
    // }
  }, [isTodosChecked])
  function decoded() {
    if (cookies?.token) {
      const userDecoded = decodedToken()
      setUser(userDecoded)
    }
  }
  useEffect(() => {
    decoded()
  }, [cookies?.token])

  function formatarCEP(cep: string) {
    if (cep) {
      cep = cep.replace(/\D/g, '');
      cep = cep.replace(/^(\d{5})(\d{3})$/, '$1-$2');
      return cep;
    }

  }

  // console.log("telefones", devedorCadastro?.telefones?.telefonecliente)

  const handleChange = ({ event, name }: HandleChangeProps) => {
    if (event && !name) {
      const { name, value } = event.target;



      let nome = name === 'N' ? 'numero' : name === 'Estado Civil' ? 'estadocivil' : name === 'Endereço' ? 'endereco' : name === 'Dia Pgto' ? 'diapgto' : name

      getClientData(prevState => ({
        ...prevState,
        [nome.toLocaleLowerCase()]: value,
      }));

      return
    }
    if (event && name) {
      const { value } = event.target;
      // const valor = new Intl.NumberFormat('pt-BR').format(Number(value))
      getClientData(prevState => ({
        ...prevState,
        [name.toLocaleLowerCase() || 'renda']: value,
      }));
      return
    }
  };

  async function handleSubmit() {
    if ((Number(clientData.diapgto) >= 0 && Number(clientData.diapgto) <= 31) || clientData.diapgto === '') {
      const dadoscadastrais = {
        empresa: clientData.empresa,
        cargo: clientData.cargo,
        renda: new Intl.NumberFormat('pt-BR').format((Number(clientData.renda) / 100)),
        dia_pgto: clientData.diapgto,
        estadocivil: clientData.estadocivil,
        motivoinadimplencia: clientData.motivoinadimplencia,
        data_atualizacao: format(new Date(), 'dd/MM/yyyy'),
        usuario_atualizacao: user?.nome || ''
      }
      const endereco = {
        desender: clientData.endereco,
        desnumer: clientData.numero,
        desbairr: clientData.bairro,
        descidad: clientData.cidade,
        desestad: clientData.uf,
        descep: clientData.cep,
        descompl: clientData.complemento,
        ultimaatualizacao: format(new Date(), 'dd/MM/yyyy'),
        id_endereco: devedorCadastro?.enderecos?.id_endereco,
        tipo_endereco: "Residencial",
        tipo_logradouro: '0'
      }
      const link = url || ''
      const codcredor = String(selectedCredor.credor_crm) || ''
      const cpfCnpj = devedor.cpf_cnpj || ''

      // console.log(String(cookies?.user?.id_operador))
      const status = await atualizaDevedorCadastro({ dadosCadastrais: dadoscadastrais, nomeclien: clientData.nome, endereco, cpf_cnpj: devedor.cpf_cnpj, url: link, codcredor, usuario: String(cookies?.user?.id_operador), datnasc: devedorCadastro?.datnasc, })

      await getDevedorCadastro(link, cpfCnpj, Number(codcredor))

      if (status === 200) {
        setModal('Devedor atualizado com sucesso!', 'Sucesso', true)
      }
    } else {
      setModal('Erro em processar o campo "Dia Pgto"! Por favor, tente novamente', 'Erro', false, true)
      return
    }
  }

  useEffect(() => {
    getClientData(prevState => ({
      ...prevState,
      'renda': Number(devedorCadastro?.dadoscadastrais?.renda.replace('.', '').replace(',', '')),
    }));
  }, [devedorCadastro?.dadoscadastrais?.renda])


  const handleValueChange = useCallback((val: any) => {
    // eslint-disable-next-line
    getClientData(prevState => ({
      ...prevState,
      'renda': val,
    }));

  }, []);


  return (
    <>
      <div className="w-full">
        <div className="flex w-full items-center gap-2 ">
          <InputBlock
            name="Nome"
            isLocked
            placeholder={devedorCadastro?.nomclien ? devedorCadastro.nomclien : ''}
          />
          <InputBlock
            name="CPF/CNPJ"
            isLocked
            placeholder={devedorCadastro?.cpfcnpj ? formatCPFCNPJ(devedorCadastro?.cpfcnpj) : ''}
          />
          <div className="text-md my-2 -mb-0.5 flex w-full items-end gap-4">
            <div className="w-[100%]">
              <p className="text-sm font-medium text-gray-800">
                Estado Civil
              </p>
              <select className="w-full rounded-sm bg-gray-200 p-3 text-gray-600 outline-none text-xs " name="Estado Civil" value={clientData.estadocivil} onChange={e => handleChange({ event: e })} >
                <option value={''}></option>
                {estadoCivil?.data?.data && estadoCivil.data.data?.message?.lista?.item?.length > 0 && estadoCivil.data.data?.message?.lista?.item.map((item: Item) => (
                  <option key={item.id} value={item.descricao}>{item.descricao}</option>
                ))}
              </select>
            </div>
          </div>

          {/* <InputBlock name="Estado Civil" width="w-[40%]" placeholder={devedorCadastro?.dadoscadastrais?.estadocivil ? devedorCadastro?.dadoscadastrais?.estadocivil : ''} value={clientData.estadocivil} onChange={e => handleChange({ event: e })} /> */}
        </div>
        <div className="my-2 flex w-full items-center gap-2">
          <InputBlock name="CEP" width="w-[40%]" placeholder={devedorCadastro?.enderecos?.descep ? formatarCEP(devedorCadastro?.enderecos.descep) : ''} onChange={e => handleChange({ event: e })} value={formatarCEP(clientData.cep || '')} />
          <InputBlock name="Endereço" placeholder={devedorCadastro?.enderecos?.desender ? devedorCadastro?.enderecos.desender : ''} onChange={e => handleChange({ event: e })} value={clientData.endereco} />
          <InputBlock name="N" width="w-[20%]" placeholder={devedorCadastro?.enderecos?.desnumer ? devedorCadastro?.enderecos.desnumer : ''} onChange={e => handleChange({ event: e })} value={clientData.numero} />
          <InputBlock name="Complemento" placeholder={devedorCadastro?.enderecos?.descompl ? devedorCadastro?.enderecos.descompl : ''} onChange={e => handleChange({ event: e })} value={clientData.complemento} />
        </div>
        <div className="my-2 flex w-full items-center gap-2">
          <InputBlock name="Bairro" width="w-[40%]" placeholder={devedorCadastro?.enderecos?.desbairr ? devedorCadastro?.enderecos?.desbairr : ''} onChange={e => handleChange({ event: e })} value={clientData.bairro} />
          <InputBlock name="Cidade" placeholder={devedorCadastro?.enderecos?.descidad ? devedorCadastro?.enderecos.descidad : ''} onChange={e => handleChange({ event: e })} value={clientData.cidade} />
          <InputBlock name="UF" width="w-[20%]" placeholder={devedorCadastro?.enderecos?.desestad ? devedorCadastro?.enderecos.desestad : ''} onChange={e => handleChange({ event: e })} value={clientData.uf} />

        </div>
        <div className="my-2 flex w-full items-center gap-2">
          <InputBlock name="Empresa" placeholder={devedorCadastro?.dadoscadastrais?.empresa ? devedorCadastro?.dadoscadastrais.empresa : ''} onChange={e => handleChange({ event: e })} value={clientData.empresa} />
          <InputBlock name="Cargo" width="w-[50%]" placeholder={devedorCadastro?.dadoscadastrais?.cargo ? devedorCadastro?.dadoscadastrais.cargo : ''} onChange={e => handleChange({ event: e })} value={clientData.cargo} />
          <InputBlock name="Dia Pgto" width="w-[30%]" type="number" max={31} min={1} defaultValue={5} placeholder={devedorCadastro?.dadoscadastrais?.dia_pgto ? devedorCadastro?.dadoscadastrais.dia_pgto : ''} onChange={e => handleChange({ event: e })} value={clientData.diapgto} />
          <div className={`text-sm flex w-[30%] flex-col gap-2`}>
            <p className="text-sm font-medium text-gray-800">Renda</p>
            <div className="flex h-10 justify-between rounded-sm bg-gray-200 px-2">
              <CurrencyInput
                max={100000000}
                placeholder={devedorCadastro?.dadoscadastrais?.renda ? devedorCadastro?.dadoscadastrais.renda : ''}
                onValueChange={handleValueChange}
                className="h-full w-full bg-transparent text-gray-600 outline-none placeholder:text-gray-500"
                value={Number(clientData?.renda) || 0}
              />
            </div>
          </div>

        </div>

        <div className="text-md my-2 flex w-full items-end gap-4">
          <div className="w-[40%]">
            <p className="text-sm font-medium text-gray-800">
              Motivo da inadimplência
            </p>
            <select className="w-full rounded-sm bg-gray-200 p-2 text-gray-600 outline-none text-xs" name="motivoinadimplencia" value={clientData?.motivoinadimplencia} onChange={e => handleChange({ event: e })} >
              <option value={''}></option>
              {motivoInadimplencia?.data?.data && motivoInadimplencia.data.data?.message?.lista?.item?.length > 0 && motivoInadimplencia.data.data?.message?.lista?.item.map((item: Item) => (
                <option key={item.id} value={item.descricao}>{item.descricao}</option>
              ))}
            </select>
          </div>

          <div>
            <p className="text-xs font-medium w-full text-gray-800">
              Inadimplência verificada?
            </p>
            <div className="flex items-center gap-2 p-2">
              <Radio name="inadimplencia" sizeText="text-xs" label="Sim" checked={inadimplencia} disabled={!clientData?.motivoinadimplencia} onChange={() => changeInadimplecia()} />
              <Radio name="inadimplencia" sizeText="text-xs" label="Não" checked={!inadimplencia} onChange={() => setInadimpelcia(!inadimplencia)} />
            </div>
          </div>

          <div>
            <p className="text-xs font-medium text-gray-800">
              Endereço verificado?
            </p>
            <div className="flex items-center gap-2 p-2">
              <Radio name="endereco" sizeText="text-xs" label="Sim" checked={endereco} onChange={() => setEndereco(!endereco)} />
              <Radio name="endereco" sizeText="text-xs" label="Não" checked={!endereco} onChange={() => setEndereco(!endereco)} />
            </div>
          </div>
          <div>
            <p className="text-xs font-medium text-gray-800">
              Renda verificada?
            </p>
            <div className="flex items-center gap-2 p-2">
              <Radio name="renda" sizeText="text-xs" label="Sim" checked={renda} onChange={() => setRenda(!renda)} />
              <Radio name="renda" sizeText="text-xs" label="Não" checked={!renda} onChange={() => setRenda(!renda)} />
            </div>
          </div>

          <div className="w-[16%]">
            <p></p>
            <div className="flex items-center gap-2 ">
              <input
                type="checkbox"
                className="h-4 w-4 rounded-sm accent-primary"
                name="todos"
                id="todos"
                checked={isTodosChecked}
                onChange={() => getTodosChecked(!isTodosChecked)}
              />
              <label htmlFor="todos" className="text-xs text-gray-700">Todos verificados</label>
            </div>
          </div>

        </div>

        {/* Tabela de Contatos */}
        <div className="my-2 flex flex-col">
          <TabelaTelefone />
          <button
            className=" ml-2 flex w-2/6 items-center justify-start gap-2 text-sm"
            onClick={() => setModal("Adicionar Telefone", "Telefone")}
          >
            {/* <img src={plusCircleIcon} alt="" /> */}
            <BsPlusCircleFill className="fill-primary" size={22} />
            Adicionar Telefone
          </button>
        </div>
        <div className="mt-2 flex flex-col">
          <TabelaEmail />
          <button
            className="ml-2 flex w-2/6 items-center justify-start gap-2 text-sm"
            onClick={() => setModal("Adicionar E-mail", "Email")}
          >
            {/* <img src={plusCircleIcon} alt="" /> */}
            <BsPlusCircleFill className="fill-primary" size={22} />
            Adicionar E-mail
          </button>
        </div>

        <div className="my-2 flex w-full items-center  gap-2 text-sm text-gray-700">
          <p className="w-full ">
            <strong className="font-semibold">Data atualização: </strong>{" "}
            {format(new Date(), 'dd/MM/yyyy')}
          </p>
          <p className="w-full">
            <strong className="font-semibold ">Usuário: </strong> {user?.nome}
          </p>
        </div>
      </div>

      <Button name="Atualizar Cadastro" type="button" onClick={() => handleSubmit()} />

      <GenericModal
        title={modalInfo.title}
        type={modalInfo.type}
        onClose={() => onClose()}
        show={modalInfo.isOpen}
        modalType="Cadastro Contato"
      />
    </>
  )
}